module.exports = __webpack_public_path__ + "static/logo22-8f4c1ac12ee771cd65f1dc69739f03e8.png";